//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"Boundaries",0,"ScCollector",0],[1,"Distance",0,"Expression",0],[1,"FacetBody",0,"SelectNXObject",0],[0,"ReverseDirection",1,0],[0,"Tolerance",1,0]],[[["nBoundaries"],"GetAllBoundaries",{R_:{boundaries:"Spline[]"}},0,0],[[],"UpdateAllBoundaries",{},0,0]],[]];
SPLM.Features.OffsetFacetBodyBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.OffsetFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;